/**
 * Executes the callback if the page is being loaded from the BF cache.
 *
 * Note: bfcache works with browser-managed navigations, it won't trigger for
 * "soft navigations" within a single-page app (SPA).
 *
 * @param callback The function to be executed.
 *
 * @see https://web.dev/articles/bfcache
 */
export function executeIfBFCached(callback: () => void): void {
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      callback();
    }
  });
}
